import { SvgIcon, SvgIconProps } from '@mui/material';


/**
 * CcfPopoverIcon used to display add event icon in the schedule panel & app space
 * @param props - SvgIconProps
 * @example -- <CcfPopoverIcon />
 */
export function CcfPopoverIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path d="M3.5 5.99609L0 0.996094L7 0.996094L3.5 5.99609Z" />
    </SvgIcon>
  );
}

export default CcfPopoverIcon;
